import React from 'react';
import classNames from "classnames";
import {TweenMax, Power1} from 'gsap';
import ButtonIcon from 'components/button/button-icon';
import Icon from 'components/icons/icon';
import Text from 'components/text/text';

export default class Dialog extends React.Component {
  constructor(props){
    super(props);

    this.setUpHandlers();
  }

  /**
   * Binds any handlers to the correct context
   *
   * @method  setUpHandlers
   */
  setUpHandlers() {
    this.onCloseClick = this.handleCloseClick.bind(this);
    this.onKeydown = this.handleKeydown.bind(this);
  }

  /**
   * React Lifecycle Hook
   * Invoked once, immediately after the initial rendering occurs.
   *
   * @method  componentDidMount
   */
  componentDidMount() {
    this.fadeIn();
    this.addListeners();
    this.focusDialogDismiss();
  }

  /**
   * React Lifecycle Hook
   * Invoked immediately before a component is unmounted and destroyed.
   * Perform any necessary cleanup in this method
   *
   * @method  componentWillUnmount
   */
  componentWillUnmount() {
    this.removeListeners();
    this.returnFocus();
  }

  fadeIn() {
    TweenMax.to(this.dialog, 0.5, {
      'opacity': 1,
      'ease': Power1.easeOut,
      'onComplete': () => {
        TweenMax.to(this.content, 0.75, {
          'opacity': 1,
          'y': 0,
          'ease': Power1.easeOut
        });
      }
    });
  }

  fadeOut(callback) {
    TweenMax.to(this.content, 0.3, {
      'opacity': 0,
      'y': 20,
      'ease': Power1.easeIn,
      'onComplete': () => {
        TweenMax.to(this.dialog, 0.5, {
          'opacity': 0,
          'ease': Power1.easeIn,
          'onComplete': callback
        });
      }
    });
  }

  /**
   * Focus management for active state of overlay
   *
   * @method  focusDialogDismiss
   */
  focusDialogDismiss() {
    this.previousFocusEl = document.activeElement;
    this.dialogDismissEl.btnRef.focus();
  }

  /**
   * Focus management for inactive state of overlay
   *
   * @method  returnFocus
   */
  returnFocus() {
    this.previousFocusEl.focus();
  }

  addListeners() {
    document.addEventListener('keydown', this.onKeydown);
  }

  removeListeners() {
    document.removeEventListener('keydown', this.onKeydown);
  }

  /**
   * Determines which methods to fire off when
   * a key is pressed when modals are open
   *
   *
   * @method  handleKeydown
   */
  handleKeydown(event) {
    if (!event) return;
    if (event.keyCode === 27) {
      this.handleCloseClick();
    }
  }

  handleCloseClick() {
    this.fadeOut(() => {
      this.props.toggleDialog(null, this.props.hasX);
    });
  }

  render() {
    const { dialogView, className, message, toggleDialog, hasX } = this.props;
    const dialogClasses = classNames(
      className,
      { 'dialog_light': dialogView && dialogView.props.theme === 'light' }
    )
    const btnClasses = classNames(
      'dialog-close',
      { 'dialog-close_hidden': !hasX }
    );
    const btnIconClasses = classNames({
      'mix-icon_strokeColorDarkest': dialogView && dialogView.props.theme === 'light',
      'mix-icon_strokeColorDefaultBlue': dialogView && dialogView.props.theme !== 'light',
    });
    const contentClasses = classNames(
      'content mix-content_alignCenter mix-content_fullHeight',
      {
        'content_lightest': dialogView && dialogView.props.theme === 'light',
        'content_darkest': dialogView && dialogView.props.theme !== 'light',
      }
    );

    return (
      <section
        id="dialog"
        className={dialogClasses}
        ref={el => { this.dialog = el; }}
      >
        <ButtonIcon
          className={btnClasses}
          iconClasses={btnIconClasses}
          description="Close Dialog"
          iconType="x"
          onClick={this.onCloseClick}
          ref={el => { this.dialogDismissEl = el; }}
        />
        <div className="dialog-content" ref={el => { this.content = el; }}>
          <div className={contentClasses}>
            {React.cloneElement(dialogView, {
              'onCloseClick': this.onCloseClick,
            })}
          </div>
        </div>
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/client/components/dialog.jsx